import { useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2, BadgeCheck } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { api } from "../../lib/api";

const ALL = "__all";
const err = (e) => toast.error(e?.response?.data?.detail || "تعذّر الحفظ");

const DeptPick = ({ ctx, value, onChange, testid }) => (
  <Select value={value || ALL} onValueChange={(v) => onChange(v === ALL ? "" : v)}>
    <SelectTrigger className="w-full sm:w-52" data-testid={testid}><SelectValue /></SelectTrigger>
    <SelectContent><SelectItem value={ALL}>كل الأقسام</SelectItem>{ctx.departments.map((d) => <SelectItem key={d.id} value={d.id}>{d.name}</SelectItem>)}</SelectContent>
  </Select>
);

export const JobTitlesPanel = ({ ctx, reload }) => {
  const [name, setName] = useState("");
  const [dep, setDep] = useState("");
  const add = async () => {
    try { await api.orgAddTitle({ name, department_id: dep }); setName(""); reload(); toast.success("تمت إضافة المسمى"); } catch (e) { err(e); }
  };
  const edit = (j, body) => api.orgEditTitle(j.id, { name: j.name, department_id: j.department_id, ...body }).then(reload).catch(err);
  const del = (j) => window.confirm(`حذف «${j.name}»؟`) && api.orgDelTitle(j.id).then(reload).catch(err);
  return (
    <div className="space-y-5" data-testid="titles-panel">
      <div className="flex flex-col gap-2 rounded-2xl border border-slate-200 bg-slate-50 p-4 sm:flex-row">
        <Input value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && name.trim() && add()} placeholder="مسمى وظيفي جديد، مثال: محاسب أول" data-testid="title-new-input" />
        <DeptPick ctx={ctx} value={dep} onChange={setDep} testid="title-new-dept" />
        <Button onClick={add} disabled={!name.trim()} className="gap-1.5" data-testid="title-new-btn"><Plus className="h-4 w-4" /> إضافة</Button>
      </div>
      {!ctx.job_titles.length && <p className="py-8 text-center text-sm text-slate-500">لا توجد مسميات بعد — أضف أول مسمى وظيفي.</p>}
      <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
        {ctx.job_titles.map((j) => {
          const n = ctx.users.filter((u) => u.job_title_id === j.id).length;
          return (
            <div key={j.id} data-testid={`title-row-${j.id}`} className="flex flex-col gap-2 rounded-xl border border-slate-200 bg-white p-3 sm:flex-row sm:items-center">
              <BadgeCheck className="hidden h-4 w-4 shrink-0 text-blue-600 sm:block" />
              <Input defaultValue={j.name} onBlur={(e) => e.target.value.trim() && e.target.value !== j.name && edit(j, { name: e.target.value.trim() })} className="h-9 flex-1 border-transparent font-semibold shadow-none hover:border-slate-200" data-testid={`title-name-${j.id}`} />
              <DeptPick ctx={ctx} value={j.department_id} onChange={(v) => edit(j, { department_id: v })} testid={`title-dept-${j.id}`} />
              <span className="shrink-0 text-[11px] text-slate-500">{n} مستخدم</span>
              <button type="button" onClick={() => del(j)} className="self-end rounded p-1.5 text-slate-400 hover:bg-red-50 hover:text-red-600 sm:self-auto" data-testid={`title-delete-${j.id}`}><Trash2 className="h-4 w-4" /></button>
            </div>
          );
        })}
      </div>
    </div>
  );
};
